import styled from "styled-components";
import logoLight from '../../assets/crivo_dark.svg';
import bgSelect from '../../assets/downSelect.svg';
import whatsapp from "../../assets/whatsapp.svg";
import instagram from "../../assets/instagram.svg";
import facebook from "../../assets/facebook.svg";
import Slide from 'react-reveal/Slide';

const FooterStyle = styled.section`

    color: #02223C;
    font-family: 'Rubik', sans-serif;
    width: 100%;
    box-sizing: border-box;
    background-color: #02223C;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #f3f3f3;

    .container {
        padding: 6rem 20px 0 20px;
        max-width: 1280px;
        width: 100%;
        height: 100%;
        display: flex;
        text-align: center;
        flex-direction: column;
    justify-content: center;
    align-items: center;

        h1 {
            font-size: 2rem;
            &.talk {
                margin-top: 12px;
                font-weight: 400;
                font-size: 1.8rem;
                border-bottom: 2px solid #f3f3f3;
            }
        }
        .social {
            padding-top: 14px 0;
            width: 72px;
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: space-around;
            margin-left: 20px;
            img {
                max-height: 28px;
                margin-left: 18px;
                height: 100%;
                filter: invert(1) brightness(1.2);
            }
        }

        form {
            max-width: 800px;
            width: 100%;
            min-height: 60px;
            margin-top: 30px;
            display: grid;
            gap: 16px;
            grid-template-columns: 1fr 1fr;
            grid-auto-flow: dense;
            padding-bottom: 36px;
            border-bottom: 0.5px solid #1B223B;
            
            label {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                span {
                    margin-bottom: 3px;
                    margin-left: 5px;
                }
            }
            .details {
                grid-column: span 2;
                textarea {
                padding: 12px 18px;
                background-color: #02223C;
                filter: contrast(0.8);
                border: none;
                font-size: 18px;
                color: white;
                border-radius: .3rem;
                width: 100%;
                resize: none;
            }
            
            }
            input, select, button {
                padding: 12px 18px;
                background-color: #02223C;
                filter: contrast(0.8);
                border: none;
                font-size: 18px;
                color: white;
                border-radius: .3rem;
                width: 100%;
                min-height: 45px;
                max-height: 45px;
                &:focus {
                    filter: contrast(0.6);
                }
            }
            select {
                -moz-appearance:none; /* Firefox */
                -webkit-appearance:none; /* Safari and Chrome */
                appearance:none;
                background-image: url(${bgSelect});
                background-repeat: no-repeat;
                background-position-x: right;
                background-position-y: center;
            }
            .send {
                grid-column: span 2;
                background-color: #F49F0A;
                color: black;
                font-weight: 600;
            }
        }
        
        .footer {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 76.19px;
            padding: 1rem 0;
            img {
                height: 40px;
            }
        }
    }

    @media screen and (max-width: 800px) {
        .container {
        }
    }

    @media screen and (max-width: 600px) {
        .container {
            
            form {
                grid-template-columns: 1fr;
                .send, .details {
                grid-column: span 1;
            }
            }

            
        }
            
    }
`

export function Footer() {

    function phoneMask(e) {
        e.target.value = e.target.value.replace(/\D/g, '');
    }

    function thanks() {
        alert('Obrigado pela mensagem! Faremos contato em breve.')
    }
    return(
        <FooterStyle id="contato">
            <div className="container" >
                <h1>O que podemos fazer por você?</h1>
                <h1 className="talk">FALE CONOSCO</h1>
                  
                <form onSubmit={thanks} action="https://send.pageclip.co/Z0iAHoFHCeBDdKt3GMcQPr3ZYQOsY04k/Contato" className="pageclip-form" method="post">
                    <Slide bottom cascade><label htmlFor="">
                        <span>Seu Nome ou Empresa: *</span>
                        <input type="text" name="contato" required/>
                    </label>
                    <label htmlFor="">
                        <span>Um telefone para contato: *</span>
                        <input type="tel" name="telefone" required onChange={phoneMask}/>
                    </label>
                    <label htmlFor="">
                        <span>Um e-mail para contato: *</span>
                        <input type="email" name="email" required/>
                    </label>
                    <label htmlFor="">
                        <span>O que deseja? *</span>
                        <select name="objetivo" required id="">
                            <option value=""></option>
                            <option value="sistema">Desenvolvimento de Sistema</option>
                            <option value="site">Criação de Site</option>
                            <option value="siteehospedagem">Site e Hospedagem</option>
                            <option value="suporte">Suporte</option>
                            <option value="lojavirtual">Loja Virtual</option>
                        </select>
                    </label>
                    <label htmlFor="" className="details" >
                        <span>Detalhe o seu projeto:</span>
                        <textarea name="descricao" id="details" rows="3" ></textarea>
                    </label>
                    <button type="submit" className="send pageclip-form__submit">Enviar mensagem</button>
                    </Slide>
                    
                </form> 
                <div className="footer">
                    <img src={logoLight} alt="" />  
                    <div className="social">
                        <a href="https://api.whatsapp.com/send?phone=5584987840947&text=Ol%C3%A1!%20Vim%20do%20site%20da%20Crivo.%20Poderia%20me%20ajudar%3F"><img src={whatsapp} className="menu_item" alt="" /></a>
                        {/* <img src={facebook} className="menu_item" alt="" /> */}
                        <a href="https://instagram.com/crivo.sitesesistemas"><img src={instagram} className="menu_item" alt="" /></a>
                    </div>  
                </div>           
            </div>
        </FooterStyle>
    )
}